import React from 'react';
import { TableCell, TableSortLabel, Box } from '@mui/material';
import { Icon } from 'semantic-ui-react';
import ColumnResizeHandle from './ColumnResizeHandle';

const ResizableSortableHeader = ({
  sortId,
  label,
  align,
  sortBy,
  sortAsc,
  setSortBy,
  setSortAsc,
  width,
  resizable,
  onResizeStart,
  className,
  ...props
}) => {
  return (
    <TableCell
      align={align || 'left'}
      sortDirection={sortBy === sortId ? (sortAsc ? 'asc' : 'desc') : false}
      className={className}
      style={{
        width: `${width}px`,
        minWidth: '60px',
        maxWidth: `${width}px`,
        position: 'relative',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        ...props.style
      }}
      {...props}
    >
      <TableSortLabel
        IconComponent={sortBy === sortId ? undefined : () => <Icon disabled name='sort' style={{marginBottom: "0.40em"}}/>}
        className={sortBy === sortId ? "sort-icon-active" : "sort-icon-inactive"}
        hideSortIcon={false}
        active={sortBy === sortId}
        direction={sortBy === sortId ? (sortAsc ? "asc" : "desc") : "desc"}
        onClick={() => {
          if(sortBy === sortId) {
            setSortAsc && setSortAsc(!sortAsc)
          } else {
            setSortBy && setSortBy(sortId)
            setSortAsc && setSortAsc(true)
          }
        }}
      >
        {label}
      </TableSortLabel>
      {resizable && (
        <ColumnResizeHandle
          columnKey={sortId}
          onResizeStart={onResizeStart}
        />
      )}
    </TableCell>
  );
};

export default ResizableSortableHeader;